export default {
    local: 'https://app.fusebox/embed/player.js',
    staging: 'https://dev.app.fusebox.fm/embed/player.js',
    production: 'https://app.fusebox.fm/embed/player.js',
};
